import React, { useState, useEffect } from "react";
import { getPlanesActivos } from "../../services/Planes";
import formatCurrency from "../../formatters/currency";
import { FaCheckCircle } from "react-icons/fa";

const CardPlanesServiciosInfo = () => {
  const [planes, setPlanes] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getPlanesActivos();
      if (res) setPlanes(res);
    };
    fetchData();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {planes.map((plan, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-md p-6 border border-gray-200 hover:shadow-lg transition-all"
        >
          <div className="flex items-center gap-3 mb-2">
            <FaCheckCircle className="text-green-600 text-lg" />
            <h3 className="text-xl font-bold text-gray-800">{plan.nombrePlan}</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">{plan.descripcion}</p>
          <p className="text-sm text-indigo-600 font-bold mt-1">
            {formatCurrency(plan.valor)}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CardPlanesServiciosInfo;
